<template>
	<div class="vx-row">
		<div
			class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3"
			style="margin-bottom: 2.2rem;"
		>
			<statistics-card-line
				:chartOptionsProp="sitesGraphs.chartOptions"
				:series="sitesGraphs.series"
				:statisticTitle="sitesGraphs.name"
			/>
		</div>

		<div
			class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
			style="margin-bottom: 2.2rem;"
		>
			<div class="vx-row">
				<template v-for="widget in rightWidgets">
					<statistics-card-line
						hideChart
						class="mb-base"
						icon-right
						:icon="widget.icon"
						:color="widget.color"
						:statistic="widget.value"
						:statisticTitle="widget.name"
						:delimited="widget.delimited"
					/>
				</template>
			</div>
		</div>

		<vx-card>
			<div class="vx-row py-2 justify-between">
				<div class="vx-col">
					<div class="perPage">
						<v-select
							class="single-row-select"
							v-model="tableMaxItems"
							label=""
							:searchable="false"
							:options="[20, 50, 100]"
						/>
					</div>
				</div>

				<div
					class="vx-col download-btn"
					:class="{ visible: isExcelFile }"
				>
					<vs-custom-button
						:disabled="!isExcelFile || loading"
						color="dark"
						type="border"
						class="vs-custom-button vs-button-text"
						@click="downloadExcelFile"
					>
						{{ $t("download") }}

						<feather-icon
							svgClasses="h-5 w-5"
							class="feather-icon"
							icon="DownloadIcon"
						/>
					</vs-custom-button>
				</div>
			</div>

			<vs-table
				:max-items="tableMaxItems"
				:data="table"
				:currentPage="currentTablePage"
				pagination
				class="table-th-center"
				@change-page="setTablePageNumber"
			>
				<template slot="thead">
					<vs-th
						v-for="fil in tableFields"
						class="justify-center text-center"
						:sort-key="fil.field.split('.')[0]"
					>
						{{ fil.title }}
					</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<template v-for="fil in tableFields">
							<vs-td
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								v-if="fil.field === 'order_id'"
							>
								<router-link :to="'ticket/' + tr.order_id">
									№ {{ tr.order_id }}
								</router-link>
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'income'"
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								class="text-success"
							>
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								v-else-if="fil.field === 'manager'"
							>
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								v-else-if="fil.field === 'website'"
							>
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								v-else-if="fil.field === 'date'"
							>
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td
								:class="{
									'text-center':
										fil.align && fil.align === 'center'
								}"
								v-else
							>
								...
							</vs-td>
						</template>
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import VSelect from "vue-select";
import notifier from "@/mixins/notifier";
import databaseManager from "@/mixins/databaseManager";
import getSitesTableFields from "@/views/Stats/stats-utils/tables/sites-table-fields";

export default {
	name: "SitesStatsComponent",

	mixins: [databaseManager, notifier],

	components: {
		StatisticsCardLine,
		VSelect
		// WidgetCard,
	},

	props: {
		filterDataCategories: {
			type: Function,
			default: undefined
		},
		chartOptions: {
			type: Object,
			default: null,
			required: true
		},
		selectedSites: {
			type: [Array, Object],
			default: () => [],
			required: true
		},
		from: {
			type: String,
			default: "",
			required: true
		},
		to: {
			type: String,
			default: "",
			required: true
		}
	},

	data() {
		return {
			loading: false,
			currentTablePage: 1,
			tableMaxItems: 20,
			tableFields: getSitesTableFields(this),
			table: [],
			excelFile: null,
			widgetSites: {
				name: this.$t("stats.salesSites"),
				rightWidgets: [
					{
						icon: "CreditCardIcon",
						code: "successRate",
						name: this.$t("stats.totalPaymentsForPeriod"),
						color: "warning",
						delimited: false,
						symbol: "",
						type: "numberOfPayments",
						data: null
					},
					{
						icon: "CreditCardIcon",
						code: "successRate",
						name: this.$t("stats.totalPaidForPeriod"),
						color: "warning",
						delimited: false,
						symbol: "",
						type: "sumOfPayments",
						data: null
					}
				]
			}
		};
	},

	watch: {
		async selectedSites(val) {
			await this.fetchSitesStats();
		},

		async from() {
			await this.fetchSitesStats();
		},

		async to() {
			await this.fetchSitesStats();
		}
	},

	computed: {
		isExcelFile() {
			return this.excelFile ? this.excelFile.file : null;
		},

		sitesGraphs() {
			let series = [];
			let chartOptions = JSON.parse(JSON.stringify(this.chartOptions));

			for (let key in this.widgetSites.data) {
				let serie = {
					name: "serie",
					data: []
				};
				this.widgetSites.data[key].forEach(({ x, y, date }) => {
					this.filterDataCategories(chartOptions, date);
					chartOptions.xaxis.categories.push(date);
					serie.data.push(y);
				});

				serie.name = key;

				series.push(serie);
			}
			if (series.length === 0) {
				chartOptions.legend.show = false;
			}
			return {
				name: this.widgetSites.name,
				series,
				chartOptions
			};
		},

		rightWidgets() {
			return this.widgetSites.rightWidgets.map(widget => {
				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value:
						widget.symbol !== undefined
							? `${value}${widget.symbol}`
							: value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				};
			});
		}
	},

	async mounted() {
		await this.fetchSitesStats();
	},

	methods: {
		async fetchSitesStats() {
			const isWebsites = this.selectedSites && this.selectedSites.length;

			if (!this.from || !this.to || !isWebsites) {
				const rightWidgets = this.widgetSites.rightWidgets.map(d => {
					d.data = null;
					return d;
				});
				this.table = [];
				this.widgetSites.data = [];
				this.widgetSites.rightWidgets = rightWidgets;
				this.excelFile = null;
				return;
			}

			try {
				const sitesArr = this.selectedSites || [];

				const requestBody = {
					from: this.from,
					to: this.to,
					sites: sitesArr.map(el => el.id)
				};

				const res = await this.dbGetSitesStatsTable(requestBody);

        this.table = res.data.map((el) => {
          return {
            ...el,
            income: +el.income,
          }
        })

				this.excelFile = this.excelFile = await this.dbGetSitesStatsTable(
					requestBody,
					true
				);

				let graphData = await this.dbGetSitesStatsGraph(requestBody);

				let numberOfPayments = await this.dbGetSitesNumberOfPayments(
					requestBody
				);

				let sumOfPayments = await this.dbGetSitesSumOfPayments(
					requestBody
				);

				const rightWidgets = this.widgetSites.rightWidgets.map(d => {
					if (d.type === "numberOfPayments") {
						d.data = numberOfPayments;
					} else if (d.type === "sumOfPayments") {
						d.data = sumOfPayments;
					}
					return d;
				});

				this.widgetSites = {
					...this.widgetSites,
					data: graphData,
					rightWidgets
				};

				this.currentTablePage = 1;
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		setTablePageNumber(data) {
			this.currentTablePage = data;
		},

		async downloadExcelFile() {
			this.loading = true;
			try {
				const link = document.createElement("a");
				link.href = this.excelFile.file;
				link.setAttribute("download", "file.zip");
				document.body.appendChild(link);
				link.click();
				setTimeout(() => {
					this.loading = false;
				}, 2000);
			} catch (e) {
				this.notifyError(e.message);
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
